// src/components/FilteredTablePage.tsx
import React, { useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import FilterComponent from './FilterComponent';
import TableComponent from './TableComponent';
import useFetchDevices from '../../hooks/useFetchDevices';
import DeviceScanControl from './DeviceScanControl';

interface FilterCriteria {
  id: string;
  ean: string;
  description: string;
}

const FilteredTablePage: React.FC = () => {
  const [filterCriteria, setFilterCriteria] = useState<FilterCriteria>({ id: '', ean: '', description: '', });

  const { apiResponse, error } = useFetchDevices(filterCriteria);

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <Container>
      <Card className='bg-white mt-4'>
        <DeviceScanControl />
        <FilterComponent onFilterChange={setFilterCriteria} />
      </Card>
      <TableComponent result={apiResponse.result} total={apiResponse.total} />
    </Container>
  );
};

export default FilteredTablePage;
